import { Component } from 'react';
import { Snackbar as MuiSnackbar } from '@mui/material';
import { SnackbarAlert } from './SnackbarAlert';
import type { SnackbarProps, SnackbarState } from './Snackbar/SnackbarProps.interface';

export class Snackbar extends Component<unknown, SnackbarState> {
  static Instance: Snackbar;

  static hide() {
    Snackbar.Instance.setState({
      open: false,
    });
  }

  static show({
    body,
    severity = 'success',
    autoHideDuration = 6000,
    action = null,
    onClose = () => {},
  }: SnackbarProps) {
    if (Snackbar.Instance) {
      Snackbar.Instance.setState({
        open: true,
        options: {
          ...Snackbar.Instance.state.options,
          severity,
          autoHideDuration,
          action,
          body: body || '',
          onClose: onClose || null,
        },
      });
    } else {
      console.warn('No snackbar found'); // eslint-disable-line
      console.warn(body); // eslint-disable-line
    }
  }

  constructor(props: never) {
    super(props);

    this.state = {
      open: false,
      options: {
        body: '',
        severity: 'success',
        autoHideDuration: 6000,
        action: null,
        onClose: () => {},
      },
    };

    Snackbar.Instance = this;
  }

  handleClose = () => {
    const { options } = this.state;

    options.onClose();

    this.setState({
      open: false,
    });
  };

  render() {
    const {
      open, options,
    } = this.state;

    return (
      <MuiSnackbar
        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
        autoHideDuration={options.autoHideDuration}
        onClose={this.handleClose}
        open={open}
      >
        <SnackbarAlert
          severity={options.severity}
          action={options.action}
          onClose={this.handleClose}
        >
          {options.body}
        </SnackbarAlert>
      </MuiSnackbar>
    );
  }
}

export * from './SnackbarAlert';
